import { render, staticRenderFns } from "./DataRegister.vue?vue&type=template&id=44cbefde"
import script from "./DataRegister.vue?vue&type=script&lang=js"
export * from "./DataRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cbefde')) {
      api.createRecord('44cbefde', component.options)
    } else {
      api.reload('44cbefde', component.options)
    }
    module.hot.accept("./DataRegister.vue?vue&type=template&id=44cbefde", function () {
      api.rerender('44cbefde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/bank/DataRegister.vue"
export default component.exports